import * as React from "react";

function SvgBranch(props, ref) {
  return (
    <svg
      id="branch_svg__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 380 380"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".branch_svg__cls-2{fill:#009bde}"}</style>
      </defs>
      <path
        d="M364.77 190.78c0-96.78-78.72-175.47-175.47-175.47S13.82 94 13.82 190.78c0 91.43 70.29 166.74 159.67 174.75h.43q2.2.19 4.41.33l.85.05q2 .12 4.06.18h1.07c1.66 0 3.32.08 5 .08s3.17 0 4.75-.07h.67q2.09-.06 4.16-.17h.28q4.67-.26 9.28-.77c87.77-9.52 156.32-84.09 156.32-174.38zM207.85 348.46l-1.69-48.53 42.38-26a31.95 31.95 0 0050-27.28 32.33 32.33 0 00-31-31 31.76 31.76 0 00-32.46 37l-29.91 18.5L203 210l41.71-25.51a37.6 37.6 0 10-14-21.09L202 181.22l-1.7-48.8a34.19 34.19 0 0021.83-33.31 34.18 34.18 0 10-46.46 33.31l-3.1 101.11-31.25-19.91a37.17 37.17 0 00-2.81-25.36c-6.25-13-18.85-22.22-33.22-23.12a39.61 39.61 0 1022.82 69.92l43.56 27.56-2.62 85.65c-78-9.95-138.58-76.78-138.58-157.49C30.53 103.24 101.75 32 189.3 32s158.77 71.22 158.77 158.77c0 81.28-61.39 148.47-140.22 157.69z"
        fill="#333e48"
      />
      <path
        className="branch_svg__cls-2"
        d="M188 79.85a20.73 20.73 0 1020.73 20.73A20.75 20.75 0 00188 79.85zM266.15 229.23A18.82 18.82 0 10285 248a18.84 18.84 0 00-18.85-18.77zM277.75 174.63a22.15 22.15 0 10-29.61-10.21 22.17 22.17 0 0029.61 10.21zM102.82 180.79a23.88 23.88 0 1023.89 23.89 23.91 23.91 0 00-23.89-23.89z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBranch);
